module.exports = __webpack_public_path__ + "img/enterprise-network-solutionsimg-3.00f2f228.png";